import { NavLink } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import { navbar } from '../copy';

export default function Nav() {
  const linkClass = ({ isActive }) => [
    'px-4 pt-3 pb-4 text-lg sm:text-xl font-semibold tracking-wide border-b-2 transition-colors cursor-none',
    isActive ? 'text-accent border-accent' : 'border-transparent hover:border-gray-300'
  ].join(' ');
  const handleClick = (e) => {
    e.currentTarget.blur();
  };

  const items = Array.isArray(navbar.navItems)
    ? navbar.navItems
    : (navbar && navbar.navItems) || [];

  return (
    <header className="bg-white dark:bg-black shadow-sm shadow-gray-300/70 sticky top-0 inset-x-0 z-20">
      <div className="max-w-5xl mx-auto flex items-center justify-center px-4 py-4 relative">
        <nav className="flex items-center gap-3">
          {items.map((item, idx) => (
            <NavLink
              key={idx}
              to={item.to}
              className={linkClass}
              onClick={handleClick}
              {...(item.end ? { end: true } : {})}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        {/* Theme toggle button */}
      </div>
        <ThemeToggle className="absolute right-8 top-1/2 -translate-y-1/2" />
    </header>
  );
}
